module.exports = "/_next/static/images/logo-2c791c9f07b7c2fdb45eb819d5e34172.svg";